import { apiActionCreator } from '../../actionCreators';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import selectors from '../../../root/shared/root';
import {
    FETCH_AMP_NAV_DATA,
    FETCH_ENROLLMENT_INFO,
    CLEAR_ADDITIONAL_ENROLLMENT_INFO,
    FETCH_ADDITIONAL_ENROLLMENT_INFO,
} from '../../actionTypes/shared/apiActionTypes';
import sharedEnrollmentClient from '../../clients/shared/EnrollmentClient';

export const fetchEnrollmentData = (params, fetchEnrollmentInfo) => async dispatch => {
    const additionalApiParams = {
        apiParams: [params],
        additionalResponseParams: { ...params },
    };

    await apiActionCreator(
        dispatch,
        FETCH_ENROLLMENT_INFO,
        fetchEnrollmentInfo,
        additionalApiParams,
    );
};

export const fetchAmpNavData = () => async dispatch =>
    apiActionCreator(dispatch, FETCH_AMP_NAV_DATA, sharedEnrollmentClient.getAmpNavData);

export const fetchSharedAdditionalEnrollmentInfo = apiCall => async (dispatch, getState) => {
    const state = getState();
    const location = selectors.getLocation(state);
    const { district, school } = getUrlParams(location);

    await apiActionCreator(dispatch, FETCH_ADDITIONAL_ENROLLMENT_INFO, () =>
        apiCall({ district, school }),
    );
};

export const clearAdditionalEnrollmentInfo = () => ({
    type: CLEAR_ADDITIONAL_ENROLLMENT_INFO,
});
